import {
  type DocsModelCapability,
  type DocsSurface,
  type DocsVisibilityAnswer,
  type DocsVisibilityGated,
  type DocsVisibleWhenLeaf,
  resolveDocsNodeVisibility,
} from '@nadoutong/contracts';

/**
 * The one call the renderer makes per section and per block. Leaf facts
 * are this surface's identity and the catalog-resolved capabilities;
 * `'unknown'` (a catalog we cannot read, a `when` this build does not
 * know) collapses to visible — the contract's conservative rule.
 */
export function docsNodeIsVisible(
  node: DocsVisibilityGated,
  surface: DocsSurface,
  available: ReadonlySet<DocsModelCapability> | null,
): boolean {
  return resolveDocsNodeVisibility(node, (leaf) => resolveDocsLeaf(leaf, surface, available));
}

function resolveDocsLeaf(
  leaf: DocsVisibleWhenLeaf,
  surface: DocsSurface,
  available: ReadonlySet<DocsModelCapability> | null,
): DocsVisibilityAnswer {
  switch (leaf.when) {
    case 'surface':
      return leaf.surface === surface;
    case 'capability_available':
      if (available === null) return 'unknown';
      return available.has(leaf.capability);
    default:
      return 'unknown';
  }
}
